export const prefixPhoneNumber = (s) => {
  const isPrefixed = s.startsWith('00') || s.startsWith('+');

  const prefixedUserInput = isPrefixed ? s.replace(/\+/g, '') : `39${s}`;

  return prefixedUserInput;
};
